import { render, staticRenderFns } from "./DetailBootcamp.vue?vue&type=template&id=2db572e2&scoped=true"
import script from "./DetailBootcamp.vue?vue&type=script&lang=js"
export * from "./DetailBootcamp.vue?vue&type=script&lang=js"
import style0 from "./DetailBootcamp.css?vue&type=style&index=0&id=2db572e2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db572e2",
  null
  
)

export default component.exports